import { useState, useMemo } from 'react';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';

import { copyTextToClipboard } from '../shared/Utilities';
import Session from '../shared/Session';
import { useParams } from "react-router-dom";
import FormHelperText from '@mui/material/FormHelperText';

export default function Secret() {
    const [secret, setSecret] = useState("");

    const { secret_key, key } = useParams();

    useMemo(() => {
        if (secret === "") {
            Session.api("POST", `/secret_value`, {secret_key: secret_key, key: key}, setSecret);
        }
    }, [secret, secret_key, key]);

    return <>
        <Typography variant="h4" align="left" gutterBottom component="h4">
            Secret
        </Typography>
        {secret === "" ? "" :
            <>
                {/* <pre className='sj-secret'><code>
                    {secret}
                </code></pre> */}
                <FormHelperText>Click to copy</FormHelperText>
                <Paper
                    className='sj-paper' 
                    onClick={() => { copyTextToClipboard(secret); }}>
                    <pre><code>
                        {secret}
                    </code></pre>
                </Paper>
                <br/>
                <br/>
                <FormHelperText>* This secret has not been stored anywhere within the platform, and this is the last time you will be able to view it.</FormHelperText>
            </>
        }
    </>;
}
